import { render, staticRenderFns } from "./VolumeTrendsLine.vue?vue&type=template&id=5b69edcf&scoped=true"
import script from "./VolumeTrendsLine.vue?vue&type=script&lang=js"
export * from "./VolumeTrendsLine.vue?vue&type=script&lang=js"
import style0 from "./VolumeTrendsLine.vue?vue&type=style&index=0&id=5b69edcf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b69edcf",
  null
  
)

export default component.exports